<template>
  <a-switch v-bind="attrs" :class="bem.b()">
    <template
      v-for="item in Object.keys($slots).filter(
        (k) => k !== 'checkedChildren' && k !== 'unCheckedChildren',
      )"
      :key="item"
      #[item]="data"
    >
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
    <template
      v-if="$slots.checkedChildren || checkedIcon || checkedLabel"
      #checkedChildren
    >
      <slot v-if="$slots.checkedChildren" name="checkedChildren"> </slot>
      <template v-else>
        <ll-icon v-if="checkedIcon" :icon-name="checkedIcon" />
        <span v-else>{{ checkedLabel }}</span>
      </template>
    </template>
    <!-- 未选中时的子元素 -->
    <template
      v-if="$slots.unCheckedChildren || unCheckedIcon || unCheckedLabel"
      #unCheckedChildren
    >
      <slot v-if="$slots.unCheckedChildren" name="unCheckedChildren"></slot>
      <template v-else>
        <ll-icon v-if="unCheckedIcon" :icon-name="unCheckedIcon" />
        <span v-else>{{ unCheckedLabel }}</span>
      </template>
    </template>
  </a-switch>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
// import { Switch } from 'ant-design-vue'
import { useAttrs } from 'vue'
import { switchProps } from './switch'

defineOptions({ name: 'LlSwitch' })

const bem = createNamespace('switch')

const attrs = useAttrs()

defineProps(switchProps)
</script>
